module.exports = __webpack_public_path__ + "static/img/advantage-technology-bg.606a5ba9.png";